import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('assigned-goals', options)



// WEBPACK FOOTER //
// ./src/store/modules/assigned-goals.js